import { CheckCircle2 } from 'lucide-react';
import { ContactNumbers } from '../../components/ContactNumbers';
import { LeadForm } from '../../components/LeadForm';

export function LeadCta(): React.JSX.Element {
  return (
    <section id="contact" className="section-surface">
      <div className="container">
        <div className="lead-section-grid">
          <div className="lead-aside section-head-anim sh-drop reveal">
            <h2 className="h2">Tell us what <span className="si accent-text">you're building</span>.</h2>
            <p className="lede">
              Describe the system you need or the process that's slowing you down.
              We'll come back with a concrete plan.
            </p>
            <ul className="lead-points">
              <li>
                <CheckCircle2 size={18} strokeWidth={2} />
                <span>
                  <b>A real reply, within one business day</b> — from an engineer, not a
                  sales sequence.
                </span>
              </li>
              <li>
                <CheckCircle2 size={18} strokeWidth={2} />
                <span>
                  <b>7+ years of production systems</b> — ERP, audit tooling, logistics
                  platforms, agentic AI.
                </span>
              </li>
              <li>
                <CheckCircle2 size={18} strokeWidth={2} />
                <span>
                  <b>Your cloud, your data</b> — we deploy to AWS, DigitalOcean, Railway,
                  Hetzner, or PythonAnywhere.
                </span>
              </li>
            </ul>

            <div className="lead-call">
              <span className="lead-call-label">Prefer to talk?</span>
              <ContactNumbers variant="aside" />
            </div>
          </div>
          <div className="reveal" data-delay="1">
            <LeadForm />
          </div>
        </div>
      </div>
    </section>
  );
}
